import React, { useState, useEffect } from 'react';
import { useContent } from '../../contexts/ContentContext';
import './ServicesAdmin.css';

const ServicesOverviewAdmin = ({ contentPath }) => {
  const { getContent, updateContent } = useContent();
  const [sectionData, setSectionData] = useState(null);

  useEffect(() => {
    setSectionData(getContent(contentPath) || { title: '', subtitle: '', stats: [] });
  }, [contentPath, getContent]);

  const handleSectionUpdate = (field, value) => {
    updateContent(`${contentPath}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleStatUpdate = (index, field, value) => {
    updateContent(`${contentPath}.stats.${index}.${field}`, value);
    setSectionData(getContent(contentPath));
  };

  const handleAddStat = () => {
    const stats = sectionData?.stats || [];
    updateContent(`${contentPath}.stats`, [...stats, { icon: 'fas fa-star', number: '', label: '' }]);
    setSectionData(getContent(contentPath));
  };

  const handleDeleteStat = (index) => {
    if (!window.confirm('Supprimer cette statistique ?')) return;
    const stats = (sectionData?.stats || []).filter((_, i) => i !== index);
    updateContent(`${contentPath}.stats`, stats);
    setSectionData(getContent(contentPath));
  };

  if (!sectionData) {
    return (
      <div className="services-admin-loading">
        <i className="fas fa-spinner fa-spin"></i>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <div className="services-admin">
      <div className="admin-section-header">
        <div className="section-info">
          <h2>
            <i className="fas fa-chart-bar"></i>
            Vue d&apos;ensemble / Statistiques
          </h2>
          <p>Bloc affiché sous l&apos;en-tête de la page Services</p>
        </div>
        <button type="button" className="btn-add-program" onClick={handleAddStat}>
          <i className="fas fa-plus"></i>
          Ajouter une statistique
        </button>
      </div>

      <div className="section-settings">
        <div className="setting-group">
          <label>Titre</label>
          <input
            type="text"
            value={sectionData.title || ''}
            onChange={(e) => handleSectionUpdate('title', e.target.value)}
            placeholder="4 Secteurs d'Excellence"
          />
        </div>
        <div className="setting-group">
          <label>Sous-titre</label>
          <textarea
            value={sectionData.subtitle || ''}
            onChange={(e) => handleSectionUpdate('subtitle', e.target.value)}
            placeholder="Découvrez notre gamme complète de services..."
            rows={3}
          />
        </div>
      </div>

      <div className="services-list-admin">
        {(sectionData.stats || []).map((stat, index) => (
          <div key={index} className="service-item-admin">
            <div className="service-header">
              <div className="service-title-area">
                <i className={stat.icon || 'fas fa-chart-line'}></i>
                <h3>Statistique {index + 1}</h3>
              </div>
              <button type="button" className="btn-delete" onClick={() => handleDeleteStat(index)} title="Supprimer">
                <i className="fas fa-trash"></i>
              </button>
            </div>
            <div className="form-grid">
              <div className="form-group">
                <label>Icône</label>
                <input
                  type="text"
                  value={stat.icon || ''}
                  onChange={(e) => handleStatUpdate(index, 'icon', e.target.value)}
                  placeholder="fas fa-graduation-cap"
                />
              </div>
              <div className="form-group">
                <label>Valeur</label>
                <input
                  type="text"
                  value={stat.number || ''}
                  onChange={(e) => handleStatUpdate(index, 'number', e.target.value)}
                  placeholder="500+"
                />
              </div>
              <div className="form-group full-width">
                <label>Libellé</label>
                <input
                  type="text"
                  value={stat.label || ''}
                  onChange={(e) => handleStatUpdate(index, 'label', e.target.value)}
                  placeholder="Dentistes Formés"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ServicesOverviewAdmin;
